var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$root.loading)?_c('div',{staticClass:"justify-content-center"},[_c('LoadingComponent',{staticStyle:{"margin":"auto"}})],1):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }